import _ from 'lodash'
let data = require('@/biz/divisions/list/enum')
export function get(group, code) {
  if (!_.has(data, group)) {
    return null
  }
  return _.get(_(_.get(data, group)).find({ code: code }), 'value')
}
